import { find, prop, propEq } from 'ramda';

export const getChildrenBySlug = (slug, navigationModules) =>
	prop('sublinks', find(propEq('slug', slug))(navigationModules));
